import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';

import { Service } from '../../../../models/service.model';
import { WidgetServicesDisplayComponent } from '../../../../shared/components/widget-displays/widget-services-display/widget-services-display.component';
import { SharedModule } from '../../../../shared/shared.module';
import {
  getActiveServices,
  getServicesLoading,
  getTotalActiveServiceLocations,
  LoadServices,
  State,
} from '../../../../store';

@Component({
  selector: 'app-ons-widget-services',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetServicesDisplayComponent, SharedModule],
  template: `
    <app-widget-services-display
      class="dimensions-stretch"
      [hyperlink]="'/services'"
      [queryParams]="{ groupBy: 'Location' }"
      [loading]="isLoading()"
      [navigateOnClick]="navigateOnClick()"
      [serviceCount]="totalOpenServices()?.length"
      [locationCount]="totalActiveLocation()"
    ></app-widget-services-display>
  `,
})
export class WidgetServicesComponent implements OnInit {
  readonly navigateOnClick = input<boolean>(false);

  private readonly store = inject(Store<State>);

  readonly totalActiveLocation = toSignal<number>(
    this.store.select(getTotalActiveServiceLocations),
  );

  readonly totalOpenServices = toSignal<Service[]>(
    this.store.select(getActiveServices),
  );

  readonly isLoading = toSignal<boolean>(this.store.select(getServicesLoading));

  ngOnInit(): void {
    this.store.dispatch(new LoadServices());
  }
}
